module.exports = __webpack_public_path__ + "static/img/104911.2f8a4efc.png";